module.exports = __webpack_public_path__ + "static/media/Congregation.473cb242.jpg";